/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CreatedCapitalActivityEventData
} from '../../model/createdCapitalActivityEventData'
import type {
  DistributionBreakdownTableDataRetrieveParams
} from '../../model/distributionBreakdownTableDataRetrieveParams'
import type {
  DistributionCreateData
} from '../../model/distributionCreateData'
import type {
  DistributionCreateDataRequest
} from '../../model/distributionCreateDataRequest'
import type {
  DistributionUnfundedBreakdownTableDataRetrieveParams
} from '../../model/distributionUnfundedBreakdownTableDataRetrieveParams'
import type {
  DistributionWithholdingCreateAPIDataRequest
} from '../../model/distributionWithholdingCreateAPIDataRequest'
import type {
  DistributionWithholdingUploadRequestDataRequest
} from '../../model/distributionWithholdingUploadRequestDataRequest'
import type {
  FeeBreakDistributionSummaryData
} from '../../model/feeBreakDistributionSummaryData'
import type {
  FeeBreakDistributionSummaryRetrieveParams
} from '../../model/feeBreakDistributionSummaryRetrieveParams'
import type {
  FeeBreakDistributionTableRetrieveParams
} from '../../model/feeBreakDistributionTableRetrieveParams'
import type {
  FeeDistributionAllocationDetailsRetrieveParams
} from '../../model/feeDistributionAllocationDetailsRetrieveParams'
import type {
  FeeDistributionAllocationSearchDataRequest
} from '../../model/feeDistributionAllocationSearchDataRequest'
import type {
  FeeDistributionAllocationSearchResultList
} from '../../model/feeDistributionAllocationSearchResultList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Creates a distribution event
 */
export const fundFamilyDistributionRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<DistributionCreateData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}`, method: 'GET', signal
    },
      options);
    }
  

export const getFundFamilyDistributionRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}`] as const;
    }

    
export const getFundFamilyDistributionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyDistributionRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>> = ({ signal }) => fundFamilyDistributionRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyDistributionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>>
export type FundFamilyDistributionRetrieveQueryError = unknown

export const useFundFamilyDistributionRetrieve = <TData = Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyDistributionRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundFamilyDistributionRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundFamilyDistributionRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>> = ({ signal }) => fundFamilyDistributionRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundFamilyDistributionRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>>
export type FundFamilyDistributionRetrieveSuspenseQueryError = unknown

export const useFundFamilyDistributionRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundFamilyDistributionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundFamilyDistributionRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundFamilyDistributionRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundFamilyDistributionRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => fundFamilyDistributionRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Creates a distribution event
 */
export const fundFamilyDistributionCreate = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    distributionCreateDataRequest: DistributionCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreatedCapitalActivityEventData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: distributionCreateDataRequest
    },
      options);
    }
  


export const getFundFamilyDistributionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyDistributionCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyDistributionCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyDistributionCreate>>, {fundFamilyId: string;fundFamilyEventId: string;data: DistributionCreateDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  fundFamilyDistributionCreate(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyDistributionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyDistributionCreate>>>
    export type FundFamilyDistributionCreateMutationBody = DistributionCreateDataRequest
    export type FundFamilyDistributionCreateMutationError = unknown

    export const useFundFamilyDistributionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyDistributionCreate>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyDistributionCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a distribution event.
 */
export const distributionDelete = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDistributionDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof distributionDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof distributionDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof distributionDelete>>, {fundFamilyId: string;fundFamilyEventId: string}> = (props) => {
          const {fundFamilyId,fundFamilyEventId} = props ?? {};

          return  distributionDelete(fundFamilyId,fundFamilyEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DistributionDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof distributionDelete>>>
    
    export type DistributionDeleteMutationError = unknown

    export const useDistributionDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof distributionDelete>>, TError,{fundFamilyId: string;fundFamilyEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getDistributionDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a breakdown of a distribution
 */
export const distributionBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDistributionBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getDistributionBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>> = ({ signal }) => distributionBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>>
export type DistributionBreakdownTableDataRetrieveQueryError = unknown

export const useDistributionBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDistributionBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>> = ({ signal }) => distributionBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>>
export type DistributionBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useDistributionBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getDistributionBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (DistributionBreakdownTableDataRetrieveParams | ((params: Params) => DistributionBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getDistributionBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => distributionBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns the allocations for either the fee break distribution or the fee holdback
 */
export const feeDistributionAllocationDetailsRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    feeDistributionAllocationSearchDataRequest: FeeDistributionAllocationSearchDataRequest,
    params: FeeDistributionAllocationDetailsRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeDistributionAllocationSearchResultList>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/fee-break-distribution-allocations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeDistributionAllocationSearchDataRequest,
        params
    },
      options);
    }
  


export const getFeeDistributionAllocationDetailsRetrieveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeDistributionAllocationDetailsRetrieve>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FeeDistributionAllocationSearchDataRequest;params: FeeDistributionAllocationDetailsRetrieveParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeDistributionAllocationDetailsRetrieve>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FeeDistributionAllocationSearchDataRequest;params: FeeDistributionAllocationDetailsRetrieveParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeDistributionAllocationDetailsRetrieve>>, {fundFamilyId: string;fundFamilyEventId: string;data: FeeDistributionAllocationSearchDataRequest;params: FeeDistributionAllocationDetailsRetrieveParams}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data,params} = props ?? {};

          return  feeDistributionAllocationDetailsRetrieve(fundFamilyId,fundFamilyEventId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeDistributionAllocationDetailsRetrieveMutationResult = NonNullable<Awaited<ReturnType<typeof feeDistributionAllocationDetailsRetrieve>>>
    export type FeeDistributionAllocationDetailsRetrieveMutationBody = FeeDistributionAllocationSearchDataRequest
    export type FeeDistributionAllocationDetailsRetrieveMutationError = unknown

    export const useFeeDistributionAllocationDetailsRetrieve = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeDistributionAllocationDetailsRetrieve>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: FeeDistributionAllocationSearchDataRequest;params: FeeDistributionAllocationDetailsRetrieveParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeDistributionAllocationDetailsRetrieveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get fee break distribution summary statistics
 */
export const feeBreakDistributionSummaryRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionSummaryRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeBreakDistributionSummaryData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/fee-break-distribution-summary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeBreakDistributionSummaryRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionSummaryRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/fee-break-distribution-summary`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeBreakDistributionSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBreakDistributionSummaryRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>> = ({ signal }) => feeBreakDistributionSummaryRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBreakDistributionSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>>
export type FeeBreakDistributionSummaryRetrieveQueryError = unknown

export const useFeeBreakDistributionSummaryRetrieve = <TData = Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionSummaryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBreakDistributionSummaryRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeBreakDistributionSummaryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionSummaryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBreakDistributionSummaryRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>> = ({ signal }) => feeBreakDistributionSummaryRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBreakDistributionSummaryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>>
export type FeeBreakDistributionSummaryRetrieveSuspenseQueryError = unknown

export const useFeeBreakDistributionSummaryRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionSummaryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBreakDistributionSummaryRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeBreakDistributionSummaryRetrieveLoader = (queryParamsOrFn: (FeeBreakDistributionSummaryRetrieveParams | ((params: Params) => FeeBreakDistributionSummaryRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeBreakDistributionSummaryRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => feeBreakDistributionSummaryRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get fee break distribution details
 */
export const feeBreakDistributionTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionTableRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/fee-break-distribution-table`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeBreakDistributionTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionTableRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/fee-break-distribution-table`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeBreakDistributionTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBreakDistributionTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>> = ({ signal }) => feeBreakDistributionTableRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBreakDistributionTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>>
export type FeeBreakDistributionTableRetrieveQueryError = unknown

export const useFeeBreakDistributionTableRetrieve = <TData = Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionTableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBreakDistributionTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeBreakDistributionTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeBreakDistributionTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>> = ({ signal }) => feeBreakDistributionTableRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeBreakDistributionTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>>
export type FeeBreakDistributionTableRetrieveSuspenseQueryError = unknown

export const useFeeBreakDistributionTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params: FeeBreakDistributionTableRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeBreakDistributionTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeBreakDistributionTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeBreakDistributionTableRetrieveLoader = (queryParamsOrFn: (FeeBreakDistributionTableRetrieveParams | ((params: Params) => FeeBreakDistributionTableRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeBreakDistributionTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => feeBreakDistributionTableRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets distribution drawdown readonly table data.
 */
export const distributionReadOnlyDrawdownTableRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/read-only-drawdown-table`, method: 'GET', signal
    },
      options);
    }
  

export const getDistributionReadOnlyDrawdownTableRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/read-only-drawdown-table`] as const;
    }

    
export const getDistributionReadOnlyDrawdownTableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionReadOnlyDrawdownTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>> = ({ signal }) => distributionReadOnlyDrawdownTableRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionReadOnlyDrawdownTableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>>
export type DistributionReadOnlyDrawdownTableRetrieveQueryError = unknown

export const useDistributionReadOnlyDrawdownTableRetrieve = <TData = Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionReadOnlyDrawdownTableRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDistributionReadOnlyDrawdownTableRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionReadOnlyDrawdownTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>> = ({ signal }) => distributionReadOnlyDrawdownTableRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionReadOnlyDrawdownTableRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>>
export type DistributionReadOnlyDrawdownTableRetrieveSuspenseQueryError = unknown

export const useDistributionReadOnlyDrawdownTableRetrieveSuspense = <TData = Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionReadOnlyDrawdownTableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionReadOnlyDrawdownTableRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getDistributionReadOnlyDrawdownTableRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getDistributionReadOnlyDrawdownTableRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => distributionReadOnlyDrawdownTableRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns an unfunded breakdown of a distribution
 */
export const distributionUnfundedBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionUnfundedBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/unfunded-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDistributionUnfundedBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionUnfundedBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/unfunded-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getDistributionUnfundedBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionUnfundedBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>> = ({ signal }) => distributionUnfundedBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionUnfundedBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>>
export type DistributionUnfundedBreakdownTableDataRetrieveQueryError = unknown

export const useDistributionUnfundedBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionUnfundedBreakdownTableDataRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDistributionUnfundedBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionUnfundedBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>> = ({ signal }) => distributionUnfundedBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionUnfundedBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>>
export type DistributionUnfundedBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useDistributionUnfundedBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string,
    params?: DistributionUnfundedBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionUnfundedBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionUnfundedBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getDistributionUnfundedBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (DistributionUnfundedBreakdownTableDataRetrieveParams | ((params: Params) => DistributionUnfundedBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getDistributionUnfundedBreakdownTableDataRetrieveQueryKey(fundFamilyId,fundFamilyEventId, queryParams),
              queryFn: () => distributionUnfundedBreakdownTableDataRetrieve(fundFamilyId,fundFamilyEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts distribution withholding based on the specified data.
 */
export const distributionWithholdingUpsert = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    distributionWithholdingCreateAPIDataRequest: DistributionWithholdingCreateAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/withholding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: distributionWithholdingCreateAPIDataRequest
    },
      options);
    }
  


export const getDistributionWithholdingUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof distributionWithholdingUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof distributionWithholdingUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingCreateAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof distributionWithholdingUpsert>>, {fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingCreateAPIDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  distributionWithholdingUpsert(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DistributionWithholdingUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof distributionWithholdingUpsert>>>
    export type DistributionWithholdingUpsertMutationBody = DistributionWithholdingCreateAPIDataRequest
    export type DistributionWithholdingUpsertMutationError = unknown

    export const useDistributionWithholdingUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof distributionWithholdingUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingCreateAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getDistributionWithholdingUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get the withholding template for a distribution
 */
export const distributionWithholdingTemplateRetrieve = (
    fundFamilyId: string,
    fundFamilyEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<Blob>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/withholding-upload`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getDistributionWithholdingTemplateRetrieveQueryKey = (fundFamilyId: string,
    fundFamilyEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/withholding-upload`] as const;
    }

    
export const getDistributionWithholdingTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionWithholdingTemplateRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>> = ({ signal }) => distributionWithholdingTemplateRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionWithholdingTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>>
export type DistributionWithholdingTemplateRetrieveQueryError = unknown

export const useDistributionWithholdingTemplateRetrieve = <TData = Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionWithholdingTemplateRetrieveQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDistributionWithholdingTemplateRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError = unknown>(fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDistributionWithholdingTemplateRetrieveQueryKey(fundFamilyId,fundFamilyEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>> = ({ signal }) => distributionWithholdingTemplateRetrieve(fundFamilyId,fundFamilyEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && fundFamilyEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type DistributionWithholdingTemplateRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>>
export type DistributionWithholdingTemplateRetrieveSuspenseQueryError = unknown

export const useDistributionWithholdingTemplateRetrieveSuspense = <TData = Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    fundFamilyEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof distributionWithholdingTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getDistributionWithholdingTemplateRetrieveSuspenseQueryOptions(fundFamilyId,fundFamilyEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getDistributionWithholdingTemplateRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,fundFamilyEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,fundFamilyEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && fundFamilyEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getDistributionWithholdingTemplateRetrieveQueryKey(fundFamilyId,fundFamilyEventId),
              queryFn: () => distributionWithholdingTemplateRetrieve(fundFamilyId,fundFamilyEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts distribution withholding based on the specified uploaded file. If none is provided, deletes any existing distribution withholding.
 */
export const distributionWithholdingByUploadUpsert = (
    fundFamilyId: string,
    fundFamilyEventId: string,
    distributionWithholdingUploadRequestDataRequest: DistributionWithholdingUploadRequestDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/distributions/fund-family-event/${fundFamilyEventId}/withholding-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: distributionWithholdingUploadRequestDataRequest
    },
      options);
    }
  


export const getDistributionWithholdingByUploadUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof distributionWithholdingByUploadUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingUploadRequestDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof distributionWithholdingByUploadUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingUploadRequestDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof distributionWithholdingByUploadUpsert>>, {fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingUploadRequestDataRequest}> = (props) => {
          const {fundFamilyId,fundFamilyEventId,data} = props ?? {};

          return  distributionWithholdingByUploadUpsert(fundFamilyId,fundFamilyEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DistributionWithholdingByUploadUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof distributionWithholdingByUploadUpsert>>>
    export type DistributionWithholdingByUploadUpsertMutationBody = DistributionWithholdingUploadRequestDataRequest
    export type DistributionWithholdingByUploadUpsertMutationError = unknown

    export const useDistributionWithholdingByUploadUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof distributionWithholdingByUploadUpsert>>, TError,{fundFamilyId: string;fundFamilyEventId: string;data: DistributionWithholdingUploadRequestDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getDistributionWithholdingByUploadUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    